module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Regular.6e2450f.woff2";